import React from 'react';
import Countdown from 'react-countdown';
import { Link } from 'react-router-dom';
import i18n from '../../i18n';
import { checkUserValidity, checkUserValidityGn, sendNotification, bidNow, getTopBidders, extraTimeCheck, toggleAutoBid,} from '../../models/auctions';
import { getLoggedUser } from '../../state/user';
import { BiddersPosition } from './biddersPosition';
import { Modal } from 'react-bootstrap';
import { formatCurrency } from '../../state/utils';
import ToggleButton from 'react-toggle-button';
import swal from 'sweetalert';
import {
  Clock,
  Users,
  Minus,
  Plus,
  Gavel,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  Info,
  Save,
  Loader2,
} from 'lucide-react';
import { SaudiRiyalLogo } from '../logo/saudiLogo';
import '../../styles/components/bidding-comp.scss';


const is_logged = localStorage.getItem('is_logged_in') ? true : false;
const user = getLoggedUser();
var countdownComplete = false;

const FinishBid = () => (
  <div className="bid-finished">
    <Clock size={20} />
    <span>{i18n.t('bid_time_ends')}</span>
  </div>
);

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    countdownComplete = true;
    return <FinishBid />;
  } else {
    return (
      <div className="countdown-container">
        <div className="countdown-icon">
          <Clock size={20} />
        </div>
        <div className="countdown-items">
          <div className="countdown-item">
            <span className="countdown-number">{days}</span>
            <span className="countdown-label">{i18n.t('lbl_day')}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{hours}</span>
            <span className="countdown-label">{i18n.t('lbl_hour')}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{minutes}</span>
            <span className="countdown-label">{i18n.t('lbl_minute')}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{seconds}</span>
            <span className="countdown-label">{i18n.t('lbl_second')}</span>
          </div>
        </div>
      </div>
    );
  }
};

let lang = localStorage.getItem('I18N_LANGUAGE');

export class BiddingComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show_auto_bid_panel: false,
      is_saving: false,
      auto_bidding: false,
      bidTimeStopped: false,
      toggleArrow: false,
      bid_increment: 0,
      auto_bid_increment: 0,
      current_bid_amount: 0,
      user_bid_amount: 0,
      target_amount: 0,
      left_button_disable: false,
      is_bid_sending: false,
      bid_place_message: '',
      bid_place_error: false,
      is_loading: false,
      user_valid: false,
      date_out_of_range: false,
      need_enroll: true,
      bid_count: 0,
      winner: {},
      is_completed: false,
      auction_page: '',
      top_bidders: {},
      enroll_status: '',
      endDate: null,
      extra_time_message: false,
      increments: [1000, 2000, 5000, 10000, 15000, 20000],
      total_enrolls: 0,
      now: new Date(),
      is_initializing: true, 

    };

    this.incrementNumber = this.incrementNumber.bind(this);
    this.decrementNumber = this.decrementNumber.bind(this);
    this.incrementAutoBidNumber = this.incrementAutoBidNumber.bind(this);
    this.decrementAutoBidNumber = this.decrementAutoBidNumber.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.bidNow = this.bidNow.bind(this);
    this.auctionFinished = this.auctionFinished.bind(this);
    this.checkUserAuctionValidity = this.checkUserAuctionValidity.bind(this);
    this.loadTopBidders = this.loadTopBidders.bind(this);
    this.checkTime = this.checkTime.bind(this);
    this.saveAutoBidOption = this.saveAutoBidOption.bind(this);
    this.incrementTime = this.incrementTime.bind(this);
  }

  componentDidMount() {
     if (!this.props.auction || !this.props.auction.id) {
      this.setState({ is_initializing: false });
      return;
    }

    let auction = this.props.auction;
    let bid_increment = 0;
    if (auction.bid_increment) {
      bid_increment = auction.bid_increment;
      this.setState({
        bid_increment: bid_increment,
      });
    }
    let auto_bid_increment = bid_increment;
    if (auction.auto_bid_increment) {
      auto_bid_increment = parseFloat(auction.auto_bid_increment);
    }
    this.setState({
      auto_bid_increment,
    });

    let start_amount = parseFloat(auction.start_amount);
    let current_bid_amount = parseFloat(start_amount);
    if (auction.latest_bid && auction.latest_bid.bid_amount) {
      current_bid_amount = parseFloat(auction.latest_bid.bid_amount);
    }
    let bid_count = auction.bid_count;
    let winner = auction.winner;
    let is_completed = auction.is_completed;
    let auction_page = this.props.auction_page;
    start_amount = parseFloat(start_amount) + parseFloat(bid_increment);
    let increments = auction.increment_numbers;
    this.setState({
      user_bid_amount: start_amount,
      target_amount: start_amount.toFixed(2),
      current_bid_amount,
      is_loading: true,
      bid_count,
      winner,
      is_completed,
      auction_page,
      endDate: auction.end_date,
      increments: increments,
    });

    this.checkUserAuctionValidity();
    if (auction && auction.id) {
      this.loadTopBidders();
      let refreshInterval = setInterval(this.loadTopBidders, 10000);
      this.setState({ refreshInterval: refreshInterval });
    }
    if (auction && auction.target_amount) {
      this.setState({ target_amount: auction.target_amount });
    }
    this.setState({ auto_bidding: auction.enabled_auto_bidding });
    let intervalId = setInterval(this.checkTime, 5000);
    this.setState({ intervalId: intervalId });
    if (this.props.auction) {
      setInterval(this.incrementTime, 1000);
    }
    
    setInterval(this.loadTopBidders, 5000);
        this.setState({ is_initializing: false });

  }

   componentDidUpdate(prevProps) {
    // Handle auction data loading after mount
    if (prevProps.auction !== this.props.auction && this.props.auction && this.props.auction.id) {
      this.initializeBiddingData();
    }
  }

  initializeBiddingData() {
    let auction = this.props.auction;
    if (!auction) return;
    
    let bid_increment = 0;
    if (auction.bid_increment) {
      bid_increment = auction.bid_increment;
      this.setState({
        bid_increment: bid_increment,
      });
    }

    let auto_bid_increment = bid_increment;
    if (auction.auto_bid_increment) {
      auto_bid_increment = parseFloat(auction.auto_bid_increment);
    }
    this.setState({
      auto_bid_increment,
    });

    let start_amount = parseFloat(auction.start_amount);
    let current_bid_amount = parseFloat(start_amount);
    if (auction.latest_bid && auction.latest_bid.bid_amount) {
      current_bid_amount = parseFloat(auction.latest_bid.bid_amount);
    }
    let bid_count = auction.bid_count;
    let winner = auction.winner;
    let is_completed = auction.is_completed;
    let auction_page = this.props.auction_page;
    start_amount = parseFloat(start_amount) + parseFloat(bid_increment);
    let increments = auction.increment_numbers;
    this.setState({
      user_bid_amount: start_amount,
      target_amount: start_amount.toFixed(2),
      current_bid_amount,
      is_loading: true,
      bid_count,
      winner,
      is_completed,
      auction_page,
      endDate: auction.end_date,
      increments: increments,
    });

    this.checkUserAuctionValidity();
    if (auction && auction.id) {
      this.loadTopBidders();
      let refreshInterval = setInterval(this.loadTopBidders, 10000);
      this.setState({ refreshInterval: refreshInterval });
    }
    if (auction && auction.target_amount) {
      this.setState({ target_amount: auction.target_amount });
    }
    this.setState({ auto_bidding: auction.enabled_auto_bidding });
    let intervalId = setInterval(this.checkTime, 5000);
    this.setState({ intervalId: intervalId });
    if (this.props.auction) {
      setInterval(this.incrementTime, 1000);
    }
    
    setInterval(this.loadTopBidders, 5000);
    
    // ... rest of your initialization logic from componentDidMount
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
    clearInterval(this.state.refreshInterval);
  }

  incrementTime() {
    let { auction } = this.props;
    if (!auction) {
      console.error('auction is undefined in props');
      return;
    }
    let dt = new Date(auction.server_time);
    dt.setSeconds(dt.getSeconds() + 1);
    auction.server_time = dt;
    this.setState({ auction });
  }

  async checkUserAuctionValidity() {
    let auction = this.props.auction;
    if (auction && auction.id) {
      this.setState({ is_loading: true });
      let response = await checkUserValidityGn({ auction: auction.id });
      if (is_logged) {
        response = await checkUserValidity({ auction: auction.id });
      }
      let data = response.data;
      if (data) {
        this.setState({ user_valid: data.valid });
        this.setState({ date_out_of_range: data.date_out_of_range });
        this.setState({ is_loading: false });
        this.setState({ total_enrolls: data.total_enrolls });
        if (data.enroll) {
          this.setState({ need_enroll: false });
        }
        if (data.enroll_status && data.enroll_status !== 'C') {
          this.setState({ enroll_status: data.enroll_status });
        }
      }
    }
  }

  async auctionFinished() {
    let auction = this.props.auction;
    await sendNotification({ auction: auction.id });
  }

  async checkTime() {
    let auction = this.props.auction;
    let endDate = this.state.endDate;

    let time = new Date().toLocaleTimeString('en-US', {
      timeZone: 'Asia/Riyadh',
    });
    let dt = new Date().toISOString('en-US').split('T')[0];
    let newDt = this.createDate(dt + ' ' + time);

    var diff = Math.abs(this.createDate(endDate) - newDt);
    var minutes = Math.floor(diff / 1000 / 60);

    if (auction && auction.id && minutes < 2) {
      const response = await extraTimeCheck({ auction: auction.id });
      let data = response.data;

      var g1 = new Date(endDate);
      var g2 = new Date(data.end_date);

      if (
        data &&
        typeof data !== 'undefined' &&
        typeof data.end_date !== 'undefined' &&
        g1.getTime() !== g2.getTime() &&
        !this.state.bidTimeStopped
      ) {
        this.createDate(data.end_date);
        this.setState({
          endDate: data.end_date,
          extra_time_message: true,
        });

        setTimeout(() => {
          this.setState({
            extra_time_message: false,
          });
        }, 3000);
      }
    }
  }

  handleChange(event) {
    let state = this.state;
    state[event.target.name] = event.target.value;
    this.setState({ state });
    if (event.target.name === 'bid_increment') {
      this.setCurrentBidAmount(event.target.value);
    }
  }

  setCurrentBidAmount(new_incr) {
    let user_bid_amount = this.state.user_bid_amount;
    let current_amount = parseFloat(this.state.current_bid_amount);
    user_bid_amount = parseFloat(current_amount) + parseFloat(new_incr);
    this.setState({ user_bid_amount });
  }

  decrementNumber() {
    let current_amount = parseFloat(this.state.current_bid_amount);
    let user_bid_amount = parseFloat(this.state.user_bid_amount);
    let bid_increment = parseFloat(this.state.bid_increment);
    user_bid_amount = parseFloat(user_bid_amount) - parseFloat(bid_increment);
    let left_button_disable = false;
    let minAmount = parseFloat(current_amount) + parseFloat(bid_increment);
    if (user_bid_amount <= minAmount) {
      left_button_disable = true;
    }
    this.setState({
      user_bid_amount: user_bid_amount,
      left_button_disable: left_button_disable,
    });
  }

  incrementNumber() {
    let current_amount = parseFloat(this.state.current_bid_amount);
    let user_bid_amount = parseFloat(this.state.user_bid_amount);
    let bid_increment = parseFloat(this.state.bid_increment);
    user_bid_amount = parseFloat(user_bid_amount) + parseFloat(bid_increment);
    let left_button_disable = true;
    if (user_bid_amount > current_amount) {
      left_button_disable = false;
    }
    this.setState({
      user_bid_amount: user_bid_amount,
      left_button_disable: left_button_disable,
    });
  }

  decrementAutoBidNumber() {
    let { target_amount, current_bid_amount, bid_increment, auto_bid_increment } = this.state;
    let minAmount = parseFloat(current_bid_amount) + parseFloat(bid_increment);
    target_amount = parseFloat(target_amount) - parseFloat(auto_bid_increment);
    if (target_amount <= minAmount) {
      swal('Not Allowed', 'Amount should be greater than current amount', 'error');
      return;
    }
    this.setState({
      target_amount: target_amount.toFixed(2),
    });
  }

  incrementAutoBidNumber() {
    let target_amount = parseFloat(this.state.target_amount);
    let bid_increment = parseFloat(this.state.auto_bid_increment);
    target_amount = parseFloat(target_amount) + parseFloat(bid_increment);
    this.setState({
      target_amount: target_amount.toFixed(2),
    });
  }

  async bidNow() {
    this.setState({ is_bid_sending: true });
    let auction = this.props.auction;
    let user_bid_amount = this.state.user_bid_amount;
    const response = await bidNow({ user_bid_amount, auction: auction.id });
    let data = response.data;
    let current_amount = data.current_amount;
    let message =
      lang === 'ar' && response.meta.message_ar && response.meta.message_ar.trim() !== ''
        ? response.meta.message_ar
        : response.message;
    this.setState({
      current_bid_amount: current_amount,
      bid_place_message: message,
      bid_place_error: data.bid_place_error,
    });

    if (data) {
      this.setState({ is_bid_sending: false });
      this.checkTime();
    }
    setTimeout(() => {
      this.setState({
        bid_place_message: '',
        bid_place_error: false,
      });
    }, 5000);

    this.loadTopBidders();
  }

  async loadTopBidders() {
    let auction = this.props.auction;
    if (auction) {
      this.setState({ loading: true });
      this.setState({ refresh_loading: true });
      const response = await getTopBidders({ auction: auction.id });
      let data = response.data;
      this.setState({ top_bidders: data });
      if (response) {
        this.setState({ refresh_loading: false });
      }
      if (response && response.meta && response.meta.bid_amount) {
        let current_bid_amount = parseFloat(response.meta.bid_amount);
        let bid_count = response.meta.bid_count;
        let user_bid_amount = parseFloat(current_bid_amount) + parseFloat(this.state.bid_increment);
        this.setState({
          current_bid_amount,
          user_bid_amount,
          bid_count,
        });
        if (this.props.updateRow && typeof this.props.updateRow === 'function') {
          this.props.updateRow(bid_count);
        }
      }
      if (response && response.meta && response.meta.myPosition) {
        let myBidData = response.meta.myPosition;
        this.setState({
          myPosition: myBidData.position,
          myPrice: myBidData.bid_amount,
        });
      }

      if (response && response.meta && response.meta.total_enrolls) {
        this.setState({ total_enrolls: response.meta.total_enrolls });
      }

      if (response && response.meta && response.meta.extra_time) {
        this.setServerTime();
      }
    }
  }

  async saveAutoBidOption() {
    this.setState({ is_saving: true });
    let { target_amount, auto_bidding, auto_bid_increment } = this.state;
    if (!auto_bidding) {
      target_amount = null;
    }
    let { auction } = this.props;
    const response = await toggleAutoBid({
      target_amount,
      auto_bidding,
      auction: auction.id,
      increment: auto_bid_increment,
    });
    if (response.success) {
      this.setState({ is_saving: false });
    } else {
      this.setState({ is_saving: false });
    }
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, '/')) : null;
  }

  render() {
    let auction = this.props.auction;
    let { auto_bidding } = this.state;
    let reg_status = auction.registartion_status;
    let endTime = new Date(this.createDate(this.state.endDate)).getTime();
    let increments = this.state.increments;
    let total_enrolls = this.state.total_enrolls;

    return (
      <div className="modern-bidding">
        <div className="bidding-card">
          <div className="bid-header">
            <div className="bidding-title">
              <div>
                <div className="bid-amount-info">
                  <div>{i18n.t('start_bid_amount')}:</div>
                  <div>
                    {' '}
                    {formatCurrency(auction.start_amount)} <SaudiRiyalLogo />{' '}
                  </div>
                </div>
                <div className="bid-amount-info">
                  {i18n.t('current_amount')}: {formatCurrency(auction.current_amount)}{' '}
                  <SaudiRiyalLogo />
                </div>
              </div>
              <div className="enrolled-count">
                <Users size={18} />
                {i18n.t('enrolled_bidders')}: {total_enrolls}
              </div>
            </div>

            {this.state.endDate && (
              <Countdown
                date={endTime}
                renderer={renderer}
                onComplete={() => {
                  this.setState({ bidTimeStopped: countdownComplete });
                }}
                now={() => new Date(auction.server_time)}
              />
            )}
          </div>
          <div className="card-body">
            {is_logged && auction.status !== 'A' && (
              <div className="status-message status-danger">{i18n.t('not_active')}</div>
            )}

            {is_logged && auction.status === 'A' && (
              <div>
                {auction.is_direct_sale === 0 && (
                  <div className="increment-selector">
                    <div className="increment-nav">
                      <div
                        className="nav-arrow"
                        onClick={() => this.setState({ toggleArrow: false })}
                      >
                        <ChevronLeft size={20} />
                      </div>

                      <div className="increment-options">
                        {increments.map((incr, i) => (
                          <button
                            key={i}
                            className={`increment-btn ${Number(this.state.bid_increment) === Number(incr) ? 'active' : ''
                              }`}
                            onClick={() => {
                              this.setState({ bid_increment: incr });
                              this.setCurrentBidAmount(incr);
                            }}
                          >
                            {incr}
                          </button>
                        ))}
                      </div>

                      <div
                        className="nav-arrow"
                        onClick={() => this.setState({ toggleArrow: true })}
                      >
                        <ChevronRight size={20} />
                      </div>
                    </div>
                  </div>
                )}

                <div className="bid-input-section">
                  <label className="form-label">{i18n.t('latest_bid_amount')}</label>
                  <div className="bid-input-group">
                    <button
                      className="input-btn"
                      disabled={this.state.left_button_disable}
                      onClick={this.decrementNumber}
                    >
                      <Minus size={20} />
                    </button>

                    <input
                      type="number"
                      name="user_bid_amount"
                      className="bid-amount-input"
                      placeholder="Bid Amount"
                      value={this.state.user_bid_amount}
                      onChange={this.handleChange}
                      readOnly={auction.is_direct_sale !== 1}
                    />

                    <button
                      className="input-btn"
                      disabled={auction.is_direct_sale === 1}
                      onClick={this.incrementNumber}
                    >
                      <Plus size={20} />
                    </button>
                  </div>
                </div>

                {/* Enrollment Section */}
                {is_logged && this.state.need_enroll && reg_status === 'open' && (
                  <div className="enroll-section">
                    {(this.state.enroll_status === 'N' ||
                      this.state.enroll_status === 'R' ||
                      this.state.enroll_status === '') && (
                        <div>
                          <div className="status-message status-danger">
                            {i18n.t('msg_enroll_waiting')}
                          </div>
                          {!auction.is_enrolled && (
                            <Link to={'/enroll/' + auction.id} className="bid-now-btn">
                              {i18n.t('enroll')}
                            </Link>
                          )}
                        </div>
                      )}

                    {this.state.enroll_status === 'N' && (
                      <div className="status-message status-danger">
                        Your enrollment verification process is pending. Please contact
                        administrator.
                      </div>
                    )}
                  </div>
                )}

                {this.state.enroll_status !== 'A' && reg_status === 'closed' && (
                  <div className="status-message status-danger">
                    {i18n.t('registration_closed')}
                  </div>
                )}

                {/* Bid Button and Auto Bidding */}
                {is_logged && auction.is_enrolled && (
                  <>
                    <button
                      className="bid-now-btn"
                      onClick={this.bidNow}
                      disabled={this.state.is_bid_sending || countdownComplete}
                    >
                      {this.state.is_bid_sending ? (
                        <>
                          <Loader2 size={20} className="spinner" />
                          Sending...
                        </>
                      ) : (
                        <>
                          <Gavel size={20} />
                          {i18n.t('bid_now')}
                        </>
                      )}
                    </button>

                    {/* Auto Bidding Section */}
                    {Boolean(auction.has_auto_bidding) && (
                      <div className="auto-bid-section">
                        <div className="auto-bid-header">
                          <div className="auto-bid-title">
                            {i18n.t('auto_bidding')}
                            <Info
                              size={16}
                              className="info-icon"
                              onClick={() => this.setState({ show_auto_bid_info: true })}
                            />
                          </div>
                          <button
                            className="toggle-btn"
                            onClick={() =>
                              this.setState({
                                show_auto_bid_panel: !this.state.show_auto_bid_panel,
                              })
                            }
                          >
                            {this.state.show_auto_bid_panel ? (
                              <ChevronUp size={20} />
                            ) : (
                              <ChevronDown size={20} />
                            )}
                          </button>
                        </div>

                        {this.state.show_auto_bid_panel && (
                          <div className="auto-bid-content">
                            <div className="auto-bid-row">
                              <span>{i18n.t('enable_auto_bidding')}</span>
                              <ToggleButton
                                inactiveLabel={i18n.t('no')}
                                activeLabel={i18n.t('yes')}
                                value={this.state.auto_bidding}
                                onToggle={(value) => {
                                  this.setState({ auto_bidding: !auto_bidding });
                                }}
                              />
                            </div>

                            <div className="auto-bid-row">
                              <span>{i18n.t('incr_amount')}</span>
                              <select
                                name="auto_bid_increment"
                                value={this.state.auto_bid_increment}
                                onChange={this.handleChange}
                                className="auto-bid-input"
                                disabled={!this.state.auto_bidding}
                              >
                                {increments.map((incr, i) => (
                                  <option key={i} value={incr}>
                                    {incr}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="auto-bid-row">
                              <span>{i18n.t('target_amount')}</span>
                              <div className="target-amount-group">
                                <button
                                  className="input-btn"
                                  onClick={this.decrementAutoBidNumber}
                                  disabled={!this.state.auto_bidding}
                                >
                                  <Minus size={16} />
                                </button>
                                <input
                                  type="number"
                                  name="target_amount"
                                  className="auto-bid-input"
                                  value={this.state.target_amount}
                                  onChange={this.handleChange}
                                  readOnly={true}
                                  disabled={!this.state.auto_bidding}
                                />
                                <button
                                  className="input-btn"
                                  onClick={this.incrementAutoBidNumber}
                                  disabled={!this.state.auto_bidding}
                                >
                                  <Plus size={16} />
                                </button>
                                <button
                                  className="save-btn"
                                  onClick={this.saveAutoBidOption}
                                  disabled={this.state.is_saving}
                                >
                                  {this.state.is_saving ? (
                                    <Loader2 size={16} className="spinner" />
                                  ) : (
                                    <Save size={16} />
                                  )}
                                  {i18n.t('save')}
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </>
                )}

                {/* Bid Message */}
                {this.state.bid_place_message && (
                  <div
                    className={`alert ${this.state.bid_place_error ? 'alert-danger' : 'alert-success'
                      }`}
                  >
                    {this.state.bid_place_message}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Login Button for Non-logged Users */}
        {!is_logged && (
          <Link to="/login" className="login-btn">
            {i18n.t('login_to_make_bids')}
          </Link>
        )}

        {/* Bidders Position Component */}
        {is_logged && this.state.top_bidders.length !== 0 && (
          <BiddersPosition
            top_bidders={this.state.top_bidders}
            loadTopBidders={this.loadTopBidders}
            refresh_loading={this.state.refresh_loading}
            user={user}
            total_enrolls={total_enrolls}
          />
        )}

        {/* Modals */}
        <Modal
          contentClassName="bg-primary"
          style={{ zIndex: '99999' }}
          size="sm"
          show={this.state.extra_time_message}
          onHide={() => this.setState({ extra_time_message: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-white">{i18n.t('message')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-white">{i18n.t('extra_time_message')}</Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-light"
              onClick={() => this.setState({ extra_time_message: false })}
            >
              {i18n.t('close')}
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          style={{ zIndex: '99999' }}
          show={this.state.show_auto_bid_info}
          onHide={() => this.setState({ show_auto_bid_info: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {i18n.t('information')} - {i18n.t('auto_bidding')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>{i18n.t('information_auto_bidding')}</Modal.Body>
        </Modal>
      </div>
    );
  }
}
